import { useCartItems } from "@faire/retailer/hooks/cart/useCartItems";
import { useCartUpdate } from "@faire/retailer/hooks/cart/useCartUpdate";
import { UpdateCartHandler } from "@faire/retailer-visitor-shared/stores/domain/CartStore/consts";

import { IProductAddOptions } from "./ProductAddOptions";
import { getUpdateCartFunction } from "./utils";

/**
 * Satisfies the IProductAddOptions interface by combining
 * useCartItems and useCartUpdate.
 */
export const useCartProductAddOptions = (
  updateItemOverride?: UpdateCartHandler
): IProductAddOptions => {
  const {
    cartItems,
    getItemByToken,
    getProductTileQuantityInCart,
    getItemByProductOptionTokenAndCustomizations,
  } = useCartItems();
  const { updateCartItemsWithUpdateHandler } = useCartUpdate();

  return {
    addedItems: cartItems,
    getAddedItemByToken: getItemByToken,
    getAddedItemQuantityByToken: getProductTileQuantityInCart,
    getAddedItemByProductOptionTokenAndCustomizations:
      getItemByProductOptionTokenAndCustomizations,
    addOrUpdateItems: () => {},
    addOrUpdateItemsV2: getUpdateCartFunction(
      updateItemOverride ?? updateCartItemsWithUpdateHandler,
      true
    ),
    addOrUpdateItemsV2withSyncInventoryFetch: getUpdateCartFunction(
      updateItemOverride ?? updateCartItemsWithUpdateHandler,
      false
    ),
  };
};
